import { __awaiter, __assign, __generator } from '../node_modules/tslib/tslib.es6.js';

var recoveryApi = {
    apppay: "slave2apppay",
    gamepay: "slave2gamepay",
    paycenter: "slave2paycenter",
    gamesdk: "slave2gamesdk",
    "rr-tools": "slave2rr-tools",
    "data-api": "slave2data-api",
    channel: "slave2channel",
    channelpnr: "slave2channelpnr",
};
var recoveryType = {
    one: 1,
    two: 2,
    three: 3,
    four: 4, //当前api 只重试一次
};
// 已成功切换的api
function getRecoverySuccessApi() {
    return JSON.parse(sessionStorage.getItem("recoverySuccessApi") || "{}");
}
/**
 * axios 版本的请求恢复
 * @param response axios 响应返回对象
 * @param axios axios 实例
 * @param api 可选替换api 参考{@link recoveryApi}
 * @param whiteList 接口状态码白名单，可添加业务错误状态码，不会再重新发送请求。
 * 使用例子
 * // 响应拦截器
 * service.interceptors.response.use(
 *  async (response: AxiosResponse) => {
 *      const res = await fetch(response,service)
 *      return res
 *  },
 *
 *  async (error: any) => {
 *    const res = await fetch(error,service)
 *    return Promise.reject(res)
 *  }
 * )
 * @returns
 */
function fetch(response, axios, api, whiteList) {
    return __awaiter(this, void 0, void 0, function () {
        var config, status, code, obj, recoverySuccessApi;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = response.config, status = response.status, code = response.code;
                    if (!(status === 200 && !code)) return [3 /*break*/, 5];
                    if (!(response.status === 200 && response.data.code == 200)) return [3 /*break*/, 1];
                    // 切换api后请求成功标记api切换成功
                    if (config.recoveryType == recoveryType.two ||
                        config.recoveryType == recoveryType.three) {
                        obj = isUrlContainsValue(config.url, api);
                        if (Object.keys(obj).length > 0) {
                            recoverySuccessApi = getRecoverySuccessApi();
                            sessionStorage.setItem("recoverySuccessApi", JSON.stringify(Object.assign(recoverySuccessApi, obj)));
                        }
                    }
                    return [2 /*return*/, response];
                case 1:
                    if (!(response.status === 200)) return [3 /*break*/, 4];
                    if (!(config.recoveryType == recoveryType.four ||
                        (Array.isArray(whiteList) && whiteList.includes(response.data.code)))) return [3 /*break*/, 2];
                    return [2 /*return*/, response];
                case 2:
                    config.recoveryType = recoveryType.four;
                    return [4 /*yield*/, axios(config)];
                case 3: return [2 /*return*/, _a.sent()];
                case 4: return [3 /*break*/, 12];
                case 5:
                    if (!((!status && code) || status !== 200)) return [3 /*break*/, 12];
                    if (!(config.recoveryType == recoveryType.one)) return [3 /*break*/, 7];
                    config.recoveryType = recoveryType.two;
                    config.url = replaceUrlKeyWithValues(config.url, api);
                    return [4 /*yield*/, axios(config)];
                case 6: return [2 /*return*/, _a.sent()];
                case 7:
                    if (!(config.recoveryType == recoveryType.two)) return [3 /*break*/, 9];
                    config.recoveryType = recoveryType.three;
                    return [4 /*yield*/, axios(config)];
                case 8: return [2 /*return*/, _a.sent()];
                case 9:
                    // 请求完4次继续报错就抛出错误 或者 code非200 第二次请求为error 也直接抛出错误
                    if (config.recoveryType == recoveryType.three ||
                        config.recoveryType == recoveryType.four) {
                        return [2 /*return*/, response];
                    }
                    if (!isUrlContainsKey(config.url, api)) return [3 /*break*/, 11];
                    config.recoveryType = recoveryType.one;
                    return [4 /*yield*/, axios(config)];
                case 10: return [2 /*return*/, _a.sent()];
                case 11: return [2 /*return*/, response];
                case 12: return [2 /*return*/];
            }
        });
    });
}
// 判断url是否包含key
function isUrlContainsKey(url, api) {
    var apis = __assign(__assign({}, recoveryApi), api);
    var keys = Object.keys(apis);
    for (var i = 0; i < keys.length; i++) {
        // 防止url上有其他类似字符
        if (url.includes("//" + keys[i] + ".")) {
            return true;
        }
    }
    return false;
}
// 替换url上的key为对应的value
function replaceUrlKeyWithValues(url, api) {
    var apis = __assign(__assign({}, recoveryApi), api);
    // 遍历对象的键
    for (var key in apis) {
        if (Object.hasOwnProperty.call(apis, key)) {
            // 判断 URL 是否包含键
            if (url.includes(key)) {
                // 替换键为对应的值
                url = url.replace("//" + key + ".", "//" + apis[key] + ".");
            }
        }
    }
    return url;
}
// 判断url是否包含value,并返回键值对
function isUrlContainsValue(url, api) {
    var _a;
    var apis = __assign(__assign({}, recoveryApi), api);
    var keys = Object.keys(apis);
    for (var i = 0; i < keys.length; i++) {
        // 防止url上有其他类似字符
        if (url.includes("//" + apis[keys[i]] + ".")) {
            return _a = {}, _a[keys[i]] = apis[keys[i]], _a;
        }
    }
    return {};
}
/**
 * 用于axios请求拦截，判断是否需要切换api
 * @param url 替换链接
 * @param api 已成功切换的api,默认值为容灾api中成功切换部分例如{gamesdk:'slave2gamesdk'}
 * @returns
 */
function replaceUrl2RetryApi(url, api) {
    var apis = __assign(__assign({}, getRecoverySuccessApi()), api);
    // 遍历对象的键
    for (var key in apis) {
        if (Object.hasOwnProperty.call(apis, key)) {
            // 判断 URL 是否包含键
            if (url.includes(key)) {
                // 替换键为对应的值
                url = url.replace("//" + key + ".", "//" + apis[key] + ".");
            }
        }
    }
    return url;
}

export { fetch, replaceUrl2RetryApi };
